import { NextSeo } from "next-seo"
import useT from "utils/useT"
import SubmitPage from "../views/submit"

const Submit = () => {
  const t = useT()
  return (
    <>
      <NextSeo
        title={"Submit your iOS iPhone App or Game | Appollow"}
        facebook={{ appId: "381042603551124" }}
        description={`${t.submit.hero} ${t.submit.descriptionSub}`}
        openGraph={{
          url: "https://www.appollow.net/submit",
          title: "Submit your iOS iPhone App or Game | Appollow",
          description: `${t.submit.hero} ${t.submit.descriptionSub}`,
          siteName: "Appollow",
        }}
        twitter={{
          site: "@Appollowapp",
          cardType: "summary_large_image",
        }}
      />
      <SubmitPage />
    </>
  )
}
export default Submit
